import { Route, Routes } from "react-router-dom";

import { Customers } from "../../pages/Customers";

export const CustomersLayout = () => {
  return (
    <Routes>
      <Route path="/" element={<Customers />} />
    </Routes>
  );
};
